import { RouteParamType } from "../../App/Routes"

export enum AppRoutes {
  ship = "ship",
  newShip = "newShip",
  launchShip = "launchShip",
  importShip = "importShip",
  accountSettings = "accountSettings",
  accountSubscription = "accountSubscription",
  accountSubscriptionComplete = "accountSubscriptionComplete",
  signup = "signup",
  launch = "launch",
  index = "index",
  unknown = "unknown",
}

export const AppViewRoutes = {
  [AppRoutes.newShip]: {
    path: ["ships", "new"],
  },
  [AppRoutes.launchShip]: {
    path: ["ships", ":shipId", "launch"],
    params: { shipId: RouteParamType.number, shipRoute: RouteParamType.route },
  },
  [AppRoutes.ship]: {
    path: ["ships", ":shipId", "*shipRoute"],
    params: { shipId: RouteParamType.number, shipRoute: RouteParamType.route },
  },
  [AppRoutes.importShip]: {
    path: ["ships", "import"],
  },
  [AppRoutes.accountSettings]: {
    path: ["account"],
  },
  [AppRoutes.accountSubscription]: {
    path: ["account", "subscription"],
  },
  [AppRoutes.accountSubscriptionComplete]: {
    path: ["account", "subscription", "complete", ":sessionId"],
    params: { sessionId: RouteParamType.string },
  },
  [AppRoutes.signup]: {
    path: ["signup"],
  },
  [AppRoutes.launch]: {
    path: ["launch"],
  },
  [AppRoutes.index]: {
    path: [],
  },
  [AppRoutes.unknown]: {
    path: ["*"],
    navigate: ["not_found"],
  },
};
